import request from "root/js/request";

export const getBloggerSubjects = async ({
  source__in,
  account_name_hash__in,
  ordering = "-post_percent",
  limit = 100,
  offset = 0,
  date,
  limited,
  ...rest
}) => {
  const response = await request({
    url: `parsers/social/subjects/`,
    method: "get",
    params: {
      source__in,
      account_name_hash__in,
      limit,
      offset,
      ordering,
      date,
      limited,
      ...rest,
    },
  });
  return response.data;
};
export const getBloggerSubjectsGrouped = async ({ subject_id__in, ...rest }) => {
  const response = await request({
    url: `parsers/social/subjects/grouped/`,
    method: "get",
    params: {
      subject_id__in,
      ...rest,
    },
  });
  return response.data;
};
